module.exports = __webpack_public_path__ + "static/media/share_twitter.0d75aa09.svg";